'use client';

import { TextVariants } from '@lichtblick/theme';
import { Option } from '@lichtblick/types';

import { Container, OptionLabel } from './SegmentedButton.styles';

import { Text } from '../Text';

type ManuallyManagedSegmentedButtonProps = {
  label?: string;
  onOptionChange: (value: string) => void;
  options: Option[];
  value?: string;
  variant?: 'tabs' | 'buttons';
};

export const ManuallyManagedSegmentedButton = ({
  label,
  onOptionChange,
  options,
  value,
  variant = 'buttons',
}: ManuallyManagedSegmentedButtonProps) => {
  return (
    <Container
      $variant={variant}
      aria-label={label ?? ''}
      onValueChange={(nextValue) => {
        if (!nextValue) {
          return;
        }

        onOptionChange(nextValue);
      }}
      type="single"
      value={value}
    >
      {options.map((option) => (
        <OptionLabel
          $variant={variant}
          data-testid={`segmented-button-${option.value}`}
          key={option.value}
          value={option.value ? option.value.toString() : ''}
        >
          {option.icon ?? null}
          <Text $variant={TextVariants.button.m}>{option.label}</Text>
        </OptionLabel>
      ))}
    </Container>
  );
};
